export { default } from './CarouselDots';

export * from './CarouselDots';
